import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()

    const uniqueId = `${Date.now()}${Math.floor(Math.random() * 1000)}`
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, uniqueId)

    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()

    const item = event.target.closest("[data-nested-form-item]")
    if (!item) return

    const destroyField = item.querySelector("input[name*='[_destroy]']")

    if (destroyField) {
      destroyField.value = "1"
      item.classList.add("hidden")
      return
    }

    item.remove()
  }
}
